"use client"

import { useEffect, useState } from "react"

interface FloatingDot {
  id: number
  size: number
  left: number
  top: number
  duration: number
  delay: number
  opacity: number
  animationType: 'float' | 'float-slow'
}

export function FloatingDots({ count = 20 }: { count?: number }) {
  const [dots, setDots] = useState<FloatingDot[]>([])

  useEffect(() => {
    // Generate random dots with varying properties
    const newDots: FloatingDot[] = Array.from({ length: count }, (_, i) => ({
      id: i,
      size: Math.random() * 10 + 6, // 6-16px
      left: Math.random() * 100, // 0-100% of container
      top: Math.random() * 80, // 0-80% (above the fold)
      duration: Math.random() * 12 + 10, // 10-22 seconds
      delay: Math.random() * 6, // 0-6 seconds
      opacity: Math.random() * 0.2 + 0.1, // 0.1-0.3 opacity (lighter)
      animationType: Math.random() > 0.5 ? 'float' : 'float-slow'
    }))
    setDots(newDots)
  }, [count])

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      {dots.map((dot) => {
        const animationName = dot.animationType === 'float-slow' ? 'float-slow' : 'float'
        return (
          <div
            key={dot.id}
            className="absolute rounded-full bg-linear-to-br from-green-200 to-emerald-300"
            style={{
              width: `${dot.size}px`,
              height: `${dot.size}px`,
              left: `${dot.left}%`,
              top: `${dot.top}%`,
              opacity: dot.opacity,
              filter: 'blur(1px)',
              boxShadow: `0 0 ${dot.size * 1.5}px rgba(134, 239, 172, 0.2), 0 0 ${dot.size * 3}px rgba(110, 231, 183, 0.1)`,
              animation: `${animationName} ${dot.duration}s ease-in-out ${dot.delay}s infinite`
            }}
          />
        )
      })}
    </div>
  )
}

